import { GaEventData } from "./GaEventData";
import { InternalEventData } from "./InternalEventData";

export class TrackedEventData {
	/**
	 * The section within the app where the usage occurred.
	 */
	section?: string;
	/**
	 * The control that can be interacted with on the page. Preview page examples: Print, Download etc.
	 */
	component?: string;
	/**
	 * Text field. type of action. ex: click/view/key presses. If clicking the control multiple times has a different affect the affect should be used instead of click. ex: Expand/Collapse, Check/Unchecked etc.
	 */
	action?: string;
	/**
	 * Extra information about the event. Could be used for what the control is targeting/referring to.
	 */
	extra?: string;
	/**
	 * GA only. text field. If nothing is set the page name is used. Context/grouping for the action.
	 */
	label?: string;
	/**
	 * A count of the event. ex: key presses
	 */
	count?: string;
	/**
	 * Used for the Non-Interaction property in Google Analytics.
	 */
	nonInteraction = false;

	createGaEventData(): GaEventData {
		const gaEventData = new GaEventData();
		gaEventData.action = this.action;
		gaEventData.label = this.label;
		gaEventData.name = this.component;
		gaEventData.category = this.section;
		gaEventData.nonInteraction = this.nonInteraction;
		return gaEventData;
	}

	createInternalEventData(): InternalEventData {
		const internalEventData = new InternalEventData();

		internalEventData.section = this.section;
		internalEventData.component = this.component;
		internalEventData.action = this.action;
		internalEventData.extra = this.extra;
		internalEventData.count = this.count;

		return internalEventData;
	}
}
